import { BorrowerIncomeType, OtherIncomeTypes } from 'enums/BorrowerIncomeType';
import { BorrowerIncomeLabel } from 'enums/BorrowerIncomeLabel';

export const INCOME_SLOT_NUMBERS = [1, 2, 3, 4, 5, 6];
export const MAXIMUM_INCOME_SOURCES = 6;
export const EMPLOYER_NAME_LABEL = 'Employer Name';
export const ANNUAL_INCOME_LABEL = 'Annual Income';
export const W2_CHECKBOX_LABEL = 'I have another W2 job to add';
export const W2_EMPLOYMENT_TYPE_LABEL = 'W2 Employment Type';
export const OTHER_INCOME_SOURCE_LABEL = 'Please Specify Source of Other Income';
export const OTHER_INCOME_SOURCE_CAPTION =
  'Income from alimony, child support, or separate maintenance payments need not to be revealed unless you choose to have it considered';
export const HOMEMAKER_UNEMPLOYED_DEFAULT_VALUE = '$0';
export const MAXIMUM_INCOME_AMOUNT_LENGTH = 9;
export const MAXIMUM_OTHER_DESCRIPTION_LENGTH = 120;
export const W2_INCOME_TYPES = [
  BorrowerIncomeType.W2,
  BorrowerIncomeType.W2SecondEmployer,
  BorrowerIncomeType.W2ThirdEmployer,
];

export const INCOME_BUTTON_TYPES = [
  BorrowerIncomeType.W2,
  BorrowerIncomeType.SelfEmployed,
  BorrowerIncomeType.VaDisability,
  BorrowerIncomeType.MilitaryPension,
  BorrowerIncomeType.EmployerPension,
  BorrowerIncomeType.SocialSecurity,
  BorrowerIncomeType.RentalIncome,
  OtherIncomeTypes.Trust,
  OtherIncomeTypes.ChildSupport,
  OtherIncomeTypes.Alimony,
  OtherIncomeTypes.FosterCare,
  OtherIncomeTypes.Annuities,
  OtherIncomeTypes.TermDisability,
  BorrowerIncomeType.HomemakerUnemployed,
  BorrowerIncomeType.Other,
];

export const INCOME_LABEL_BY_TYPE = {
  [BorrowerIncomeType.W2]: BorrowerIncomeLabel.W2,
  [BorrowerIncomeType.W2SecondEmployer]: BorrowerIncomeLabel.W2,
  [BorrowerIncomeType.W2ThirdEmployer]: BorrowerIncomeLabel.W2,
  [BorrowerIncomeType.SelfEmployed]: BorrowerIncomeLabel.self_employed,
  [BorrowerIncomeType.VaDisability]: BorrowerIncomeLabel.va_disability,
  [BorrowerIncomeType.MilitaryPension]: BorrowerIncomeLabel.military_pension,
  [BorrowerIncomeType.EmployerPension]: BorrowerIncomeLabel.employer_pension,
  [BorrowerIncomeType.SocialSecurity]: BorrowerIncomeLabel.social_security,
  [BorrowerIncomeType.RentalIncome]: BorrowerIncomeLabel.rental_income,
  [BorrowerIncomeType.HomemakerUnemployed]: BorrowerIncomeLabel.homemaker_unemployed,
  [BorrowerIncomeType.Other]: BorrowerIncomeLabel.other,
  [BorrowerIncomeType.OtherDescription]: BorrowerIncomeLabel.other_description,
  [OtherIncomeTypes.Trust]: BorrowerIncomeLabel.trust,
  [OtherIncomeTypes.ChildSupport]: BorrowerIncomeLabel.child_support,
  [OtherIncomeTypes.Alimony]: BorrowerIncomeLabel.alimony,
  [OtherIncomeTypes.FosterCare]: BorrowerIncomeLabel.foster_care,
  [OtherIncomeTypes.Annuities]: BorrowerIncomeLabel.annuities,
  [OtherIncomeTypes.TermDisability]: BorrowerIncomeLabel.term_disability,
};
